var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-toast-container"},[_c('b-toast',{ref:"globalToast",attrs:{"toaster":"b-toaster-top-center","title":_vm.toast?.title,"variant":_vm.toast?.variant,"no-auto-hide":_vm.toast?.noAutoHide,"auto-hide-delay":"3000"},on:{"hidden":_vm.onToastHidden}},[_vm._v(" "+_vm._s(_vm.toast?.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }